import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutObjectionList extends Layout {
    layoutheaderSearchObjections: LayoutHeader;
    sourceObjection: DataSource;
    tableObjections: Table;
}
